<template>
    <div :class="css.container" v-loading="loading" v-if="exist">
        <!-- * 头部 -->
        <div :class="css.header">
            <!-- * 名称 -->
            <h3 :class="css.name" class="font-variable font-bold color-1">{{ name }}</h3>
            <!-- * 排序模式控制器 -->
            <DefaultSelector :class="css.modes" v-model="mode" :candidates="option" @change="methods.mode" />
        </div>

        <div :class="css.body" ref="canvas"></div>
    </div>
</template>

<script lang="tsx" setup>
//* 内部组件
import { DefaultSelector } from "@/components/controls";
//* 组件属性
import { ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 组件属性注册
const define = defineProps(ModulePropsOption);

//* 组合函数
const { vars, refs, methods, computeds } = useComposable(define);
const { mode, loading, exist } = refs;
const { render, hidden } = methods;
const { option } = computeds;

//* 组件属性导出
defineExpose({ render, hidden });
//* 组件卸载时, 销毁可视化图形
onBeforeUnmount(() => {
    vars.canvas?.destroy();
});
</script>
